import './loadingCompletionDetails.css';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, NavItem } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { useNavigate } from "react-router-dom";
import { authKey,GET_ADVANCED_SHIPMENT_DETAILS} from '../../../common/URLs';
import { useState } from 'react';

import { useEffect } from "react";
import { PROD } from '../../../common/constants';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { toast } from 'react-toastify';
import apiClient from '../../../axios';

function LoadingCompletionDetails() {

    const navigate = useNavigate();

    const[advanceShipmentDetails, setAdvanceShipmentDetails] = useState();

    useEffect(() => {
      getAdvanceShipmentDetails();
    }, []);

    const getAdvanceShipmentDetails = () => {
      apiClient
        .post(GET_ADVANCED_SHIPMENT_DETAILS,
          {
            "stakeholderType": "LLE",
            "stakeholderUrn": "URN-LLELL00302",
            "consignmentNumber": "CON-00002"
          },
          {
            headers: {
              Authorization:'Bearer ' + getLocalStorageItem('id_token'),
            }
          }, null,
        )
        .then((response) => {
         setAdvanceShipmentDetails(response.data);
          console.log("hlo",advanceShipmentDetails);
        })
        .catch(function (error) {
          console.log(error);
          toast.error(error.message);
        });
    }

    return(
        <div>  
            <Container fluid>
              <Row>
                 <Col xs={12} md={12}>
                    <div className="loading-completion-div">
                    {!PROD &&    <p style={{textAlign:"center", fontSize:"2vh"}}>PIT40</p> }
                       <form>
                          <Container fluid>
                          <p className="headingStylePIT">Loading Completion/Advance Shipment Details</p>
                            <Row>
                              <Col xs={12} md={4}>
                              <div className="loading-completion-label">Consignment No </div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.consignmentNo}/>
                                 <div className="loading-completion-label">Date & Time of Loading Completion</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.consignmentPickDate}/>
                                 <div className="loading-completion-label">Vehicle No & Details</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails?.vehicleRegNo}/>
                                 <div className="loading-completion-label">Driver Name & Details</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails?.driverName}/>
                              </Col>
                              <Col xs={12} md={4}>
                              <div className="loading-completion-label">Bill To Name</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.billingName}/>
                                 <div className="loading-completion-label">Bill To Address</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.billingAddress}/>
                                 <div className="loading-completion-label">Ship To Name</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.shippingName}/>
                                 <div className="loading-completion-label">Ship To Address</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.shippingAddress}/>
                              </Col>
                              <Col xs={12} md={4}>
                                 <div className="loading-completion-label">Consignment Weight</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.totalWeight}/>
                                 <div className="loading-completion-label">Estimated Date Of Arrival</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails?.dateOfArrivaldateOfArrival}/>
                                 <div className="loading-completion-label">Estimated Time Of Arrival</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true}/>
                              </Col>
                            </Row>
                          </Container>
                          <p className="loading-completion-grower-text">Grower Details</p>
                          <Container fluid>
                            <Row>
                              <Col xs={12} md={4}>
                                 <div className="loading-completion-label">Invoice No </div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.consignmentSourceDetails[0].acknowledgementId} />
                                 <div className="loading-completion-label">Grower PO No</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.consignmentSourceDetails[0].sourceStakeholderPo}/> 
                              </Col>
                              <Col xs={12} md={4}>
                                 <div className="loading-completion-label">Grower No</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.consignmentSourceDetails[0].sourceStakeholderPo}/>
                              </Col>
                              <Col xs={12} md={4}>
                                 <div className="loading-completion-label">Grower URN</div>
                                 <input className='loading-completion-textfields' type="text" disabled={true} value={advanceShipmentDetails ?.consignmentSourceDetails[0].sourceStakeholderUrn}/>
                              </Col>
                            </Row> 
                          </Container>
                       </form>
                    </div>
                 </Col>
              </Row>
            </Container>
        </div>
    )
  }
  export default LoadingCompletionDetails;